// extracted by mini-css-extract-plugin
export default {"wrap":"ot-z","melodyCategory":"pt-z","fullWidth":"qt-z","items":"rt-z","featureCss":"st-z","disabled":"tt-z","imgCss":"ut-z"};